import { useState } from "react";
import {
  MiBox,
  MiBuildPageHeader,
  MiButton,
  MiIcon,
  MiList,
} from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  PAGINATION,
  PERMISSIONS,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { mdiHomeGroup, mdiPlus } from "@mdi/js";
import { useTheme } from "@mui/material";
import { usePermissions } from "../../hooks";
import { CreateCommunityDrawer } from "./CreateCommunityDrawer/CreateCommunityDrawer";
import { useCommunitiesViewModel } from "./useCommunitiesViewModel";

export function Communities() {
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false);

  const theme = useTheme();
  const { navigate } = useRouter();
  const {
    getCommunities,
    communities,
    isLoading,
    search,
    setCommunities,
    setSearch,
    debouncedSearch,
  } = useCommunitiesViewModel();
  const { hasPermission } = usePermissions();

  const canCreateCommunity = hasPermission(PERMISSIONS.COMMUNITY.CREATE);

  const handleCreateDrawerClose = () => setIsCreateDrawerOpen(false);

  const sections = [
    {
      fieldset: [
        {
          label: "Community",
          field: "name",
          width: 150,
        },
        {
          label: "State",
          field: "regionCode",
        },
        {
          label: "City",
          field: "city",
          renderValue: ({ city }) => city?.cityName,
        },
        {
          label: "Latitude",
          field: "location",
          renderValue: ({ location }) => location?.Latitude.toFixed(6),
        },
        {
          label: "Longitude",
          field: "location",
          renderValue: ({ location }) => location?.Longitude.toFixed(6),
        },
        {
          label: "Total Homes",
          field: "totalCountOfHomes",
        },
      ],
    },
  ];

  return (
    <>
      <MiBuildPageHeader
        title="Communities"
        search={search}
        onHandleSearch={(e) => setSearch(e.target.value)}
        titleIcon={
          <MiIcon
            path={mdiHomeGroup}
            size={1}
            color={theme.palette.primary.main}
          />
        }
        loading={isLoading}
        actionComponent={
          canCreateCommunity && (
            <MiButton
              title="Community"
              variant={BUTTON_VARIANTS.CONTAINED}
              startIcon={{
                path: mdiPlus,
              }}
              onClick={() => setIsCreateDrawerOpen(true)}
              data-testid="Add Community"
            />
          )
        }
      />
      <MiBox height="100%">
        <MiList
          viewType="card"
          cardProps={{
            sections,
            onClick: (item) => {
              navigate(`/communities/${item.id}/summary`);
            },
            leftCardProps: { fieldset: [] },
          }}
          data={communities}
          loading={isLoading}
          search={debouncedSearch}
          setData={setCommunities}
          dataProvider={getCommunities}
          paginationMode={PAGINATION.SERVER}
          groupedMode
          groupedCriteria={(item) => item?.builder?.name}
          emptyListProps={{
            text: "No Communities found",
          }}
        />
      </MiBox>
      <CreateCommunityDrawer
        open={isCreateDrawerOpen}
        onClose={handleCreateDrawerClose}
      />
    </>
  );
}
